// extracted by mini-css-extract-plugin
export default {"root":"Breadcrumbs__root--2DEsq","button_back":"Breadcrumbs__button_back--3XeXh"};